/**
 * Warm the caches a freshly minted draft's review needs BEFORE navigating to
 * it: the canonical ``/concept-group/:id`` page's detail (which decides
 * draft-review vs library view) and the draft review's preview detail. With
 * both warm the destination renders immediately — no skeleton flash between
 * the upload finishing and the review appearing. Failures are swallowed: the
 * navigation still happens and the destination fetches normally (the old,
 * flashing behavior becomes the fallback).
 *
 * Lives in feature-project-page (not the shared concept-group-detail lib)
 * because it bridges that lib's created-group reads with feature-epi-chat's
 * preview reads — and the shared lib must not depend on feature-epi-chat.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */

import type { useQueryClient } from '@tanstack/react-query';

import {
  conceptGroupKeys,
  fetchConceptGroupDetail,
} from '@verantos-dev/feature-concept-group-detail';
import {
  conceptGroupPreviewKeys,
  fetchConceptGroupPreviewDetail,
} from '@verantos-dev/feature-epi-chat';

export const prefetchDraftReviewData = async (
  queryClient: ReturnType<typeof useQueryClient>,
  { conceptGroupId, previewId }: { conceptGroupId: string | null; previewId: string }
): Promise<void> => {
  try {
    await Promise.all([
      conceptGroupId
        ? queryClient.prefetchQuery({
            queryKey: conceptGroupKeys.detail(conceptGroupId),
            queryFn: () => fetchConceptGroupDetail(conceptGroupId),
          })
        : Promise.resolve(),
      previewId
        ? queryClient.prefetchQuery({
            queryKey: conceptGroupPreviewKeys.detail(previewId),
            queryFn: () => fetchConceptGroupPreviewDetail(previewId),
          })
        : Promise.resolve(),
    ]);
  } catch {
    // Best-effort warm-up only — never block the navigation on it.
  }
};
